import SentientCardCreator from './components/home';

export default function App() {
  return (
    <div className="min-h-screen w-full bg-gray-900">
      {/* Background elements */}
     
      <SentientCardCreator />
    
    </div>
  );
}
